import React from 'react';
import {
  IconButton,
  IconButtonProps,
  IconButtonSize,
  IconButtonVariant
} from '../IconButton';
import { colorGrayDusk } from '@hse-design/tokens';

export type HeaderIconProps<
  ComponentType extends React.ElementType
> = IconButtonProps<ComponentType>;

export function HeaderIcon(props: HeaderIconProps<'button'>): JSX.Element;
export function HeaderIcon<ComponentType extends React.ElementType>(
  props: HeaderIconProps<ComponentType>
): JSX.Element;
export function HeaderIcon<ComponentType extends React.ElementType>(
  props: HeaderIconProps<ComponentType>
) {
  return (
    <IconButton
      variant={IconButtonVariant.ghost}
      size={IconButtonSize.medium}
      iconColor={props.iconColor ?? colorGrayDusk}
      {...props}
    />
  );
}
